import AppBarTop from 'components/AppBarTop'
import Copyright from 'components/Copyright'

import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'


const Thanks = () => {
    return (
        <>
            <AppBarTop />
            <Container maxWidth='md'>
                <Grid container mt={4}>
                    <Grid item xs={12} py={2} px={1}>
                        <Typography variant='h6' align='center'>Thank you for signing up to the Narcan Training Sessions. You may now close this page.</Typography>
                    </Grid>
                </Grid>
                <Copyright />
            </Container>
        </>
    )
}

export default Thanks
